import { Breadcrumb } from './../../base-models/breadcrumb';
import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd, ActivatedRoute, PRIMARY_OUTLET } from '@angular/router';
import { filter, distinctUntilChanged, map, last } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'yt-breadcrumbs',
    templateUrl: './breadcrumbs.component.html'
})
export class Breadcrumbs implements OnInit {
    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute
    ){}

    rootBreadcrumb: Breadcrumb = {
        Label: 'Početna',
        Url: ''
    }
    breadcrumbs$ = this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                distinctUntilChanged())
                .subscribe(event => {
                    this.breadcrumbs = this.buildBreadcrumbs(this.activatedRoute.root)
                    this.breadcrumbs = [this.rootBreadcrumb, ...this.breadcrumbs];
                })
            

    breadcrumbs: Breadcrumb[];

    ngOnInit(){
        
    }

    private buildBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: Array<Breadcrumb> = []): Array<Breadcrumb>{
        let children: ActivatedRoute[] = route.children;

        if(children.length == 0){
            return breadcrumbs;
        }

        for(let child of children){
            if(child.outlet !== PRIMARY_OUTLET 
                || child.snapshot.url.length == 0
                ){
                //continue;
                return this.buildBreadcrumbs(child, url, breadcrumbs);
            }

            if(!child.snapshot.data.hasOwnProperty('breadcrumbLabel')){
                return this.buildBreadcrumbs(child, url, breadcrumbs);
            }

            let routeUrl: string = child.snapshot.url.map(segment => segment.path).join('/');
            url += `/${routeUrl}`;

            let breadcrumb: Breadcrumb = {
                Label: child.snapshot.data['breadcrumbLabel'],
                Url: url
            }

            breadcrumbs.push(breadcrumb);

            return this.buildBreadcrumbs(child, url, breadcrumbs);
        }
        return breadcrumbs;
    }
}